import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import type { Subscription } from 'rxjs/Subscription';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { NEW_GROUP_ID } from '../../../../common/constants';
import { getGroupSelector } from '../../selectors';
import type { ImmutableState } from '../../types';
import type { ActionCallback } from '../types';
import { addGroupMutator } from '../utils';

const createTemplate =
	(callback: ActionCallback<boolean>) =>
	({ setState, getState }: StoreActionApi<ImmutableState>): Subscription => {
		const state = getState();
		const templateExists = Boolean(getGroupSelector(state, NEW_GROUP_ID));

		if (!templateExists) {
			setState(addGroupMutator({ id: NEW_GROUP_ID, name: '' }, state));
		}

		return Observable.of(templateExists).subscribe(callback);
	};

export default createTemplate;
